export default __webpack_public_path__ + "static/media/lastfm.47999064.svg";